import React from 'react';
import InputWrapper from 'shared-components/helper-components/input-wrapper/input-wrapper';
import { useAdditionalFieldValue } from 'shared-components/helper-components/create-input/use-additional-field-value';
import PhoneInputComposite from './PhoneInputComposite';
import { usePhoneInputState } from './usePhoneInputState';
import { useMaskedPhoneDisplay } from './useMaskedPhoneDisplay';
import { useDefaultPhoneCountry } from './useDefaultPhoneCountry';

const InternationalPhoneField = (props) => {
  const {
    input,
    errors,
    onChange,
    onBlur,
    onFocus,
    onClick,
    fields,
    required = [],
    template = {},
    cashier_theme,
    langBack,
    s,
    layout,
    fieldType,
    isPixV2,
  } = props;

  const { name, label, type } = input;

  const { inputValue, readOnly } = useAdditionalFieldValue({
    input,
    fields,
    template,
    isPixV2,
  });

  const { isMasked, isEditing, showLiveInput, enterEditMode, exitEditMode } = useMaskedPhoneDisplay(
    { value: inputValue },
  );

  const defaultCountry = useDefaultPhoneCountry();

  const {
    codes,
    prefix,
    number,
    countryCode,
    isModalOpen,
    setIsModalOpen,
    handleNumberChange,
    handlePrefixChange,
  } = usePhoneInputState({
    name,
    value: isMasked ? '' : inputValue || '',
    valueFormat: 'e164',
    onChange,
    defaultCountry,
    dataset: { additionalFieldType: type },
  });

  const getError = () => {
    const isOptional = input.required === false || input.required === 0;
    const isEmpty = (fields[name] ?? '').toString().trim() === '';
    const isAmountFirstLayout = layout === 'amount-first';

    if (isAmountFirstLayout && isOptional && isEmpty) {
      return null;
    }

    if (required.includes(name) && errors[name]) {
      return errors[name];
    }

    if (!required.includes(name) && isEmpty) {
      return null;
    }

    return errors[name] ? errors[name] : null;
  };

  const getPlaceholder = () => {
    if (input?.placeholder) {
      return langBack(input.placeholder);
    } else if (cashier_theme !== 'power-slide') {
      return layout === 'amount-first' ? (label ? langBack(label) : name) : langBack(label);
    } else {
      return '';
    }
  };

  const displayTitle =
    layout === 'amount-first' ? (label ? langBack(label, true) : name) : langBack(label, true);

  const handleFocus = (fieldName) => {
    if (!readOnly) enterEditMode();
    onFocus(fieldName);
  };

  const handleBlur = () => {
    exitEditMode();
    onBlur && onBlur();
  };

  const showComposite = showLiveInput;

  return (
    <InputWrapper fieldType={fieldType} title={displayTitle} error={getError()} name={name}>
      {showComposite ? (
        <PhoneInputComposite
          name={name}
          codes={codes}
          prefix={prefix}
          number={number}
          countryCode={countryCode}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          onNumberChange={handleNumberChange}
          onPrefixChange={handlePrefixChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={getPlaceholder()}
          disabled={readOnly}
          required={required.includes(name)}
          langBack={langBack}
          s={s}
          autoFocus={isEditing}
        />
      ) : (
        <input
          onClick={() => (typeof onClick === 'function' && !readOnly ? onClick() : false)}
          className={`${s('input')} ${readOnly ? s('read-only') : ''} phone-input__masked`}
          value={inputValue ?? ''}
          name={name}
          type="tel"
          required={required.includes(name)}
          readOnly
          disabled={readOnly}
          placeholder={getPlaceholder()}
          onFocus={() => handleFocus(name)}
          onBlur={handleBlur}
        />
      )}
    </InputWrapper>
  );
};

export default InternationalPhoneField;
